<template>
<div class="chapter">
<div class="inner_page">
<h2 class="contentsHead" id="contenthtml">Contents</h2>
<p class="contentsEntryText"><a href="#/Text/d920_1000">Prologue</a></p>
<p class="contentsEntryText"><a href="#/Text/d920_1001">One</a></p>
<p class="contentsEntryText"><span href="#/Text/d920_1002" title="Link target outside of Sample">Two</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1003" title="Link target outside of Sample">Three</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1004" title="Link target outside of Sample">Four</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1005" title="Link target outside of Sample">Five</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1006" title="Link target outside of Sample">Six</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1007" title="Link target outside of Sample">Seven</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1008" title="Link target outside of Sample">Eight</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1009" title="Link target outside of Sample">Nine</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1010" title="Link target outside of Sample">Ten</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1011" title="Link target outside of Sample">Eleven</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1012" title="Link target outside of Sample">Twelve</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1013" title="Link target outside of Sample">Thirteen</span></p>
<p class="contentsEntryText"><span href="#/Text/d920_1014" title="Link target outside of Sample">Epilogue</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7c5c92b1